import { render } from "./Profile.vue?vue&type=template&id=4232fa58&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=4232fa58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4232fa58"

export default script